"use client";

import { useSyncExternalStore } from "react";
import { formatCampaignCountdown, type CampaignCopy } from "@/lib/campaigns/promotion/config";

function subscribe(onChange: () => void) {
	const timer = window.setInterval(onChange, 1000);
	window.addEventListener("focus", onChange);
	document.addEventListener("visibilitychange", onChange);
	return () => {
		window.clearInterval(timer);
		window.removeEventListener("focus", onChange);
		document.removeEventListener("visibilitychange", onChange);
	};
}

const serverSnapshot = () => null;

/** Stable server/hydration deadline; fixed bar height and timer width prevent clock layout shifts. */
export function CampaignCountdown({
	locale,
	endsAt,
	copy,
}: {
	locale: string;
	endsAt: string;
	copy: CampaignCopy;
}) {
	const remainingSeconds = () => Math.max(0, Math.ceil((Date.parse(endsAt) - Date.now()) / 1000));
	const seconds = useSyncExternalStore<number | null>(subscribe, remainingSeconds, serverSnapshot);
	if (seconds === 0) return null;
	return (
		<div
			role="note"
			lang={locale === "de" ? "de" : "en"}
			aria-label={copy.bannerLabel}
			className="flex h-9 items-center justify-center border-b border-border bg-primary px-2 text-center text-[11px] font-medium leading-tight text-primary-foreground sm:text-sm"
		>
			<span>
				{copy.banner} ·{" "}
				<span
					aria-live="off"
					className="inline-block w-[29ch] whitespace-nowrap text-left align-bottom tabular-nums"
				>
					{seconds === null
						? copy.bannerDeadline
						: `${copy.bannerCountdown} ${formatCampaignCountdown(seconds, locale)}`}
				</span>
			</span>
		</div>
	);
}
